<div class="n-weekly-calendar">
  <!-- Cabeçalho -->
  <div class="custom-header-container">
    <div class="grid w-full">
      <div class="col-6 sm:col-8 md:col-6 lg:col-4">
        <div class="w-full flex justify-content-between">
          <!-- Rótulo de período (semana/mês/ano) -->
          <button
            class="custom-header-label-button"
            (click)="alternarVisualizacao()"
            [attr.aria-label]="'BARDO_AGENDA.ALTERNAR_VISUALIZACAO' | translate"
          >
            {{ $periodLabel() }}
          </button>
        </div>
      </div>
      <div class="col-4 sm:col-4 md:col-6 lg:col-8 flex justify-content-end">
        <p-button
          [rounded]="true"
          icon="pi pi-calendar"
          [label]="'BARDO_AGENDA.HOJE' | translate"
          (onClick)="irParaHoje()"
        />
      </div>
      <div class="col-2 sm:col-4 md:col-6 lg:col-8 flex justify-content-end">
        <button
          class="n-btn-visualizar-dias-confirmados"
          (click)="alternarVisualizacaoDiasConfirmados()"
        >
          <span class="{{ $iconVisualizarDiasConfirmados() }}"></span>
        </button>
      </div>
    </div>
  </div>

  <!-- Dias da semana com suporte a swipe (Angular 19 @for) -->
  <div
    class="n-days-container"
    #daysContainer
    [attr.aria-label]="
      'Semana de ' + $periodLabel() + '. Deslize para navegar entre semanas'
    "
  >
    @for (dia of diasSemana(); track dia.data.getTime()) {
    <div
      class="n-day-card"
      [class.n-day-selected]="dia.isSelecionado"
      [class.n-day-today]="dia.isHoje"
      [class.n-day-other-month]="dia.isOutroMes"
      [class.n-day-holiday]="dia.isFeriado"
      tabindex="0"
      role="button"
      (click)="selecionarDia(dia)"
      (keyup.enter)="selecionarDia(dia)"
      [attr.aria-label]="
        dia.diaSemana +
        ', ' +
        dia.dia +
        (dia.isHoje ? ' (hoje)' : '') +
        (dia.isSelecionado ? ' (selecionado)' : '') +
        (dia.isFeriado ? ' (feriado)' : '')
      "
      [attr.aria-pressed]="dia.isSelecionado"
      pRipple
    >
      <div class="n-day-number">{{ dia.dia }}</div>
      <div class="n-day-name">{{ dia.diaSemana }}</div>
      <!-- TODO: Converter ngClass para @if quando dateClass estiver funcional -->
      <div [ngClass]="{ 'n-possui-agendamento': dateClass(dia.data) }"></div>
    </div>
    }
  </div>

  <!-- Indicador de swipe (opcional - para feedback visual) -->
  <div class="n-swipe-indicator">
    <div class="n-swipe-hint">
      <i class="pi pi-angle-left"></i>
      <span>{{ 'BARDO_AGENDA.DESLIZE_PARA_NAVEGAR' | translate }}</span>
      <i class="pi pi-angle-right"></i>
    </div>
  </div>
</div>
